import { SimulationNodeDatum, forceManyBody } from 'd3-force';

import { D3LayoutNode } from 'src/containers/ProjectDiagram/templates/extensions/layouts/ForceDirectedLayout/types';
import { ForceLayoutSettings } from 'src/containers/ProjectDiagram/templates/extensions/layouts/types';

export const forceManyBodySimulation = (layoutSettings: ForceLayoutSettings) =>
  forceManyBody().strength(
    (x: SimulationNodeDatum) =>
      -(x as D3LayoutNode).radius *
      layoutSettings.layoutManyBodyStrengthMultiplier
  );
